// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.

// MENU
const burger = document.querySelector('.navbar-toggler');

burger.onclick = function () {
  this.classList.toggle('active');
  document.querySelector('.nav').classList.toggle('open');
};

const parentMenu = document.querySelectorAll('.menu-item-has-children');
const subMenuOpen = document.querySelectorAll('.menu-item-has-children .sub-menu.open');

parentMenu.forEach(function (i) {

  i.addEventListener("mouseenter", function (event) {
    this.classList.add('active');
    this.querySelector('.sub-menu').classList.add('open');
  }, false);

  i.addEventListener("mouseleave", function (event) {
    setTimeout(function () {
      event.target.classList.remove('active');
      event.target.querySelector('.sub-menu').classList.remove('open');
    }, 100);
  }, false);

});
subMenuOpen.forEach(function (i) {

  subMenuOpen.addEventListener("mouseover", function (event) {
    event.target.classList.add('open');
    event.target.parentNode.classList.add('active');
  }, false);

  subMenuOpen.addEventListener("mouseleave", function (event) {
    setTimeout(function () {
      event.target.classList.remove('open');
      event.target.parentNode.classList.remove('active');
    }, 100);
  }, false);

});


const borders = document.querySelectorAll(".border");
const myImgs = document.querySelectorAll('img');
const imgCols = document.querySelectorAll('.full-left, .full-right');
const imgCovers = document.querySelectorAll('.page-head .img, .page-head .img img');
const buttons = document.querySelectorAll('.wp-block-button');


let observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.intersectionRatio > 0) {
      entry.target.classList.add('animated');
      /*    entry.target.style.opacity = entry.intersectionRatio;*/
    }
  });
});


borders.forEach(border => {
  /*  border.classList.add('animate-me');*/
  observer.observe(border);
});
imgCols.forEach(img => {
  observer.observe(img);
});
buttons.forEach(button => {
  observer.observe(button);
});
imgCovers.forEach(img => {
  observer.observe(img);
});
/*

myImgs.forEach(image => {
  observer.observe(image);
});*/



// WEBPACK FOOTER //
// ./resources/assets/js/app.js